
$(window).on("load", function(){
  var Bestsellers = $('.home_page_slider');  
$(Bestsellers).not(".slick-initialized").slick({
     	dots: false,
  		infinite: true,
  		speed: 300,
  		slidesToShow: 4,
    	slidesToScroll: 4,
        arrows: false,
  		adaptiveHeight: false,
   		centerMode: true,
         responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              centerMode: true,
              infinite: true,

              dots: false
            }
          },
          {
            breakpoint: 768,
            settings: "unslick"
          },
           {
            breakpoint: 200,
            settings: "unslick"
          }          
        ]
  });

 var slick1 = $('#lavido_index_slider').slick({
      	dots: false,
  		infinite: true,
  		speed: 300,
  		slidesToShow: 3,
    	slidesToScroll: 3,
        arrows: false,
  		adaptiveHeight: true,
   		centerMode: true,
         responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              centerMode: true,
              infinite: true,
    		  
              dots: false
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
        
	});
  
  
  /*
    Slides 2-9 of the homepage carousel are held back by full-width-carousel.liquid
    so they stay off the critical path: desktop backgrounds sit in data-bg, mobile
    photos are loading=lazy. This puts them back once the page has finished
    loading, and early if the carousel moves first (autoplay fires at ~3s, which
    on a slow connection can beat window.load).

    Runs after slick init so the query also picks up slick's infinite-mode clones,
    which are cloned from this same markup and carry the same attributes.

    The mobile <img>s are only upgraded under 767px, which is the only width where
    they resolve to a real photo - above it the <picture> hands back a transparent
    gif, so there would be nothing to gain.
  */
  function hydrateCarouselSlides() {
    $('.full-width-carousel__slide[data-bg]').each(function () {
      this.style.backgroundImage = 'url(' + this.getAttribute('data-bg') + ')';
      this.removeAttribute('data-bg');
    });

    if (window.matchMedia('(max-width: 767px)').matches) {
      $('.full-width-carousel .slide__image--mobile[loading="lazy"]').each(function () {
        this.loading = 'eager';
      });
    }
  }

  // Bound before init on purpose: slick fires beforeChange on this element, so a
  // handler attached now still runs on the very first transition.
  var full_width_carousel = $('.full-width-carousel')
    .on('beforeChange', hydrateCarouselSlides)
    .slick({
	    autoplay: true,
      	dots: false,
  		infinite: true,
  		slidesToShow: 1,
    	slidesToScroll: 1,
        arrows: false,
  		adaptiveHeight: true,
	});

  if (document.readyState === 'complete') {
    hydrateCarouselSlides();
  } else {
    $(window).on('load', hydrateCarouselSlides);
  }

 $(window).resize('width', function () {
    // slick1.slick("refresh");
    // Bestsellers.slick("refresh");
    // bestSeller_collection();
   
  });
  bestSeller_collection();

  function bestSeller_collection(){
      var $skincare_product_slider = $('#skincare_product_slider');
    
      if($(window).width()< 767){
           $skincare_product_slider.slick({
             dots: false,
             infinite: true,
             speed: 300,
             adaptiveHeight: true,
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             centerMode: true        
        });
        
      }else{
     	$skincare_product_slider.slick('destroy');;
      }
  }
  
  
  $('#productPageSlider').slick({
      	dots: false,
  		infinite: true,
  		speed: 300,
  		slidesToShow: 4,
    	slidesToScroll: 1,
        arrows: true,
  		adaptiveHeight: true,
    	centerMode: true,
    
         responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
        
	});
  
  
});
// isotope only ships on the press template now, so guard before calling it.
$(window).on("load", function(){
  if ($.fn.isotope && $(".section-press").length) {
    $(".section-press").isotope({
      itemSelector: '.col-content'
    });
  }
});


$(document).ready(function(){

  
    // Geo redirect: runs after first paint so the ipinfo.io round trip (DNS +
    // TLS to a third-party host) does not sit on the critical path.
    var geoRedirect = function() {
      $.get("https://ipinfo.io", function(response) {
        if(response.country == 'CA'){
          window.location.href = "https://www.lavido.ca/";
        }else if(response.country == 'NL'){
          window.location.href = "https://www.lavido.nl/";
        }
      }, "jsonp");
    };
    /*if (window.requestIdleCallback) {
      requestIdleCallback(geoRedirect, { timeout: 2000 });
    } else {
      setTimeout(geoRedirect, 0);
    }*/

  
    
  	 var header_reading = $('.jdgm-rev-widg__summary .jdgm-rev-widg__summary-stars').attr('aria-label');
  if(header_reading !== undefined){
     header_reading = header_reading.replace(/[^0-9]/g,'')/100;  
     $('.jdgm-rev-widg__header').prepend('<div class="header_reading">'+header_reading+'</div>');
  }
     
      
  $('.min_qty_sign').click(function(){
    	var qty = parseInt($('.product-form input[name="quantity"]').val());
    if(qty != 1){
      qty -=1;
      $('.product-form input[name="quantity"]').val(qty);
    }
  });
  
   $('.plug_qty_sign').click(function(){
    	var qty = parseInt($('.product-form input[name="quantity"]').val());     
      	qty +=1;
      	$('.product-form input[name="quantity"]').val(qty);
     
  });
  
  $('.logo-bar .logo-bar__item').on("click mouseover", function(){
    	var id = $(this).attr('data-id');
    	$('.logo-bar .logo-bar__item, .bar_section .section-header').removeClass('active');
    	$(this).addClass('active');
		$('.bar_section .section-header[data-id="'+id+'"]').addClass('active');                        
  });
  
  $(".collapsible-btn .faq-btn").on("click", function(e){
    var _this = $(this);
    	setTimeout(function(){
    	_this.toggleClass("active");
    }, 60);
      event.preventDefault();
      $(this).parent().next('.faq-content').stop().slideToggle("fast");
    
      
    });
  
  
  
  $("#homePageShowMore").click(function(){
    $("#addActiveClass").addClass("active");
});
  
  $('.accouding_heading').click(function(){
    var id= $(this).attr('data-id');
    $(this).toggleClass('active');
    $('.accouding_item[data-id="'+id+'"]').slideToggle();
    
  });
  
  $('.flag_menu').click(function(){
    	$('.show_flag').slideToggle();
  });
  
  /*
  $("#slideNext").on("click", function(){
    $(".product-single__thumbnails li a").removeClass("active-thumb");
    $(".product-single__thumbnails li").each(function(index){
      if($(this).children("a").hasClass("active-thumb")) {
        if($(this).next("li").length > 0) {
          $(this).next("li").children("a").addClass("active-thumb");
          
        }
        else {
          $(".product-single__thumbnails li:eq(0)").children("a").addClas("active-thumb");
        }
      }
    });
  });
  */
  
  
  $('body').on('click', '.arr-wrapper .arrow_pdimg', function(){
    
     var li_active = 0;
     $('.product-single__thumbnails li').each(function(){
      	  li_active +=1;
          if($(this).find('a').hasClass('active-thumb')){
             return false;
          } 
      });
    
      if($(this).hasClass('arr-left')){
         li_active -=1;
      }else{
        li_active +=1;
      }     
      
      var total_img = $('.product-single__thumbnails li').size();
             
      if(li_active > 0 & li_active <= total_img){
        li_active -=1;       
        $('.product-single__thumbnails li').eq(li_active).find('a').trigger('click').addClass('active');
      }
    
  });
  
  
  
 
        
  
});

$(window).scroll(function(){
   
  var scroll = $(window).scrollTop();   
  if(scroll > 300){
    $('body').addClass('active_scroll');
  }else{
    $('body').removeClass('active_scroll');
  }
});

$(document).ready(function(){
  $('#announcementBarClose').click(function(){
  	$('a.announcement-bar').hide();
  });
  
  
 $('.mobileSecondMenu').addClass('active');
  
   var lastScrollTop = 0;
    $(window).on('scroll', function() {
        st = $(this).scrollTop();
      
        if ($(window).width() < 768) {
          if(st < 60 ){
             // $('.mobileSecondMenu').addClass('active');
          } else{
            if(st < lastScrollTop) {
                // $('.mobileSecondMenu').addClass('active');
             // $('.mobileSecondMenu.inactive').removeClass('inactive');
             // $('.mobileSecondMenu.active').slideDown(350);
            }
            else {
              // $('.mobileSecondMenu').removeClass('active');
             // $('.mobileSecondMenu.active').removeClass('active');
             // $('.mobileSecondMenu').addClass('inactive');
              //$('.mobileSecondMenu.inactive').slideUp(350);
            }
          }
        }
        lastScrollTop = st;
    });
  
  $(window).on('resize', function() {
        
      if ($(window).width() > 767) {
        $('.mobileSecondMenu').slideUp(350);
      }
  });
  
  $("body").on("click", ".pdacd_subheading", function(e){
    $("#ingredients-popup").addClass("active");
  });
  $("body").on("click", "#ig-close", function(e){
    $("#ingredients-popup").removeClass("active");
  });

 $("body").on("click", ".js-toggle-submenu", function(e){
   e.preventDefault();
 var n=$(this).next();
 if($(n).hasClass("is-transitioning")){
    $(n).removeClass("is-transitioning");
 }else{
   $(n).addClass("is-transitioning");
 }
   
if($(".mobile-nav-wrapper").hasClass("sub-nav--is-open")){
  $(".mobile-nav-wrapper").removeClass("sub-nav--is-open");
}else{
   $(".mobile-nav-wrapper").addClass("sub-nav--is-open");
}
   if($(this).hasClass("is-active")){
   $(this).removeClass("is-active");
   }else{
   $(this).addClass("is-active");     
   }
});
});

// Attach the footer background only when the footer is close to the viewport.
// Falls back to loading it immediately where IntersectionObserver is missing.
(function () {
  var attach = function (el) { el.classList.add('footer-bg-loaded'); };
  var init = function () {
    var footer = document.querySelector('.site-footer');
    if (!footer) { return; }
    if (!('IntersectionObserver' in window)) { attach(footer); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          attach(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px 0px' });
    io.observe(footer);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// infiniteScroll only ships on collection/search templates now.
 $(function() {
   if ($.fn.infiniteScroll && $('.lazyload_1').length) {
     $('.lazyload_1').infiniteScroll({
          itemSelector: 'li.pd_laz_itmes',
          dataPath: '',
          onDataLoaded: 'li.pd_laz_itmes'
     });
   }
 });

